import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, Bandeira, Grupo, RetAPI, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { useSelector } from 'react-redux'
import { createTheme, ThemeProvider } from '@mui/material'
import { selectUser } from '../Redux/userSlice'
import { GrupoService } from '../../Pages/Grupo/GrupoService'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import moment from 'moment'
import { Tooltip } from 'react-tooltip'
import { RiEdit2Fill } from 'react-icons/ri'
import { FaTrashAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { BandeiraService } from '../../Pages/Bandeira/BandeiraService'
import { Funcoes } from '../../Utils/Funcoes'

type Props = {
    bandeira: Bandeira[],
    handleUpdateBandeiraList: () => void
}

type VisibilityState = Record<string, boolean>

interface RowData {
    id: number,
    id_empresa: number,
    id_user_insert: number,
    id_user_last_update: number,
    id_user_exclusao: number,
    dt_cadastro: string,
    dt_last_update: string,
    dh_exclusao: string,
    motivo_exclusao: string,
    name_user_insert: string,
    name_user_last_update: string,
    name_user_delete: string,
    nome: string,
    nome_resumido: string,
    cnpj: string,
    taxa: number,
    dias: string,
    description: string,
}

export const GridBandeira = React.memo(({ bandeira, handleUpdateBandeiraList }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_bandeira")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_bandeira") || '')
                : {
                    dt_cadastro: true,
                    name_user_insert: false,
                    nome: true,
                    nome_resumido: true,
                    cnpj: false,
                    taxa: true,
                    dias: true,
                }
        )
    }, [])

    const [idBandeira, setIdBandeira] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [bandeiras, setBandeiras] = useState<Bandeira[]>([])
    const [nomeBandeira, setNomeBandeira] = useState("")

    let user = useSelector(state => selectUser(state))


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setBandeiras(bandeira)
    }, [bandeira])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_bandeira", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await BandeiraService.Delete(idBandeira, motivo, senha)
            Inputfocus()

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Bandeira excluída com sucesso`)

                handleUpdateBandeiraList()

                //setModalShow(false)
                //setGrupos(await GrupoService.Filter('', '', ''))

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
                //setModalShow(false)
            }

        } catch (error) {
            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir a bandeira. Por favor, tente novamente`)
        }

    }, [idBandeira])

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa_bandeira")
        inputElement?.focus()
    }

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)

        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeBandeira("")
        }
    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeBandeira("")
    }, [])

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaBandeiraEdit = (id: number) => {
        navigate(`/bandeira/edit/${id}`)
    }


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const colunas = useMemo<MRT_ColumnDef<Grupo>[]>(
        () => [

            {
                accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: true, size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    const navegar = () => {
                        navegarTelaBandeiraEdit(rowData.id)
                    }

                    const handleExcluirClick = () => {

                        const timerExcluir = setTimeout(() => {
                            setIdBandeira(rowData.id)
                            setNomeBandeira(rowData.nome)
                            setModalShow(true)

                            let divPerfil = document.getElementById('div-perfil') as HTMLDivElement

                            if (divPerfil) {
                                divPerfil.classList.add('hidden')
                            }

                            
                            let menuFiltro = document.getElementById("divMenuFiltroBandeira") as HTMLDivElement
                            let menuInputs = document.getElementById("divInputsBandeira") as HTMLDivElement

                            if (menuFiltro) {

                                menuInputs.classList.add("invisible")

                                const timer = setTimeout(() => {
                                    menuFiltro.classList.remove("max-h-[390px]")
                                    menuFiltro.classList.add("max-h-[0px]")
                                    Inputfocus()
                                    clearTimeout(timer)
                                }, 100)
                            }
                            

                            clearTimeout(timerExcluir)
                        }, 0);

                    }

                    return (
                        <div className={`flex justify-start w-full`}>

                            <button
                                onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                          bg-sky-500`}>
                                <RiEdit2Fill size="20px" />
                                <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                    <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                                </Tooltip>
                            </button>

                            <button
                                onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                                className={`flex items-center justify-center 
                                          text-white transition-all duration-300 
                                          hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                          bg-red-500 ml-2`} >
                                <FaTrashAlt size="18px" />
                                <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed"  >
                                    <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                                </Tooltip>
                            </button>

                        </div>
                    )
                }
            },

            {
                accessorKey: 'nome', visibleInShowHideMenu: true, header: 'Nome', size: 250, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.nome ? rowData.nome : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'nome_resumido', visibleInShowHideMenu: true, header: 'Nome Resumido', size: 250, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.nome_resumido ? rowData.nome_resumido : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'taxa', visibleInShowHideMenu: true, header: 'Taxa(%)', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.taxa ? Funcoes.numberFormat(rowData.taxa.toString(), 'decimal') : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'dias', visibleInShowHideMenu: true, header: 'Dias', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.dias ? rowData.dias : <span className='text-red-400'>N/D</span>}</span>)

                }
            },

            {
                accessorKey: 'dt_cadastro', visibleInShowHideMenu: true, header: 'Data', size: 100, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

                Cell: (cell: any) => {

                    const rowData = cell.row.original as RowData

                    return (<span>{rowData.dt_cadastro ? moment(rowData.dt_cadastro).format("DD/MM/YYYY") : <span className='text-red-400'>N/D</span>}</span>)

                }
            }

        ], []
    )

    const table = useMaterialReactTable({
        columns: colunas,
        data: bandeiras,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: true,
        enableColumnFilters: false,
        enableHiding: true,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir a bandeira - ${nomeBandeira || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>
    )

})